<template>
  <div>
        <!-- Upcoming Meetings -->
        <b-container fluid>
          <b-row no-gutters>
            <b-col cols="8">
              <div id="buttons" class="ml-4 mr-5">
                <!-- <h2 style="display:inline">My Meetings</h2> &nbsp;&nbsp;&nbsp; -->
                <span style="font-size: 1.4rem; position:relative; top:3px" class="sectionLabel">My Meetings</span>&nbsp;&nbsp;&nbsp;
                <b-button variant="primary" :to="{name: 'EditMeeting'}">Schedule a Meeting</b-button>&nbsp;&nbsp;&nbsp;
                <b-button variant="primary" @click="meetNow()">Meet Now</b-button></div>
            </b-col>
            <b-col cols="4" style="display: flex">
              <div style="align-self:center; width:90%" >
                <b-form-input placeholder="Search Meetings" v-model="meetingSearchTerm" ></b-form-input>
              </div>
            </b-col>
          </b-row>
        </b-container>

<!--    <template>-->
      <div  class="ml-4 mr-4">
          <b-container fluid v-if="upcomingMeetings.length == 0" >
      <b-row>
        <b-col cols="4">
           <b-card nobody class="itemCutOut">
            <div>You don't have any meetings yet</div><br />
              <div style="color:var(--primaryColor1);cursor: pointer" @click="meetNow">
                Click <b>Meet Now</b> to try creating a meeting.
              </div>
          </b-card>
        </b-col>
        <b-col></b-col>
        <b-col></b-col>
      </b-row>
      </b-container>

        <b-container fluid>
          <b-row>
          <b-col cols="4" v-for="(meeting, idx) in upcomingMeetings" v-bind:key="idx">
             <b-card no-body @click="openMeeting(meeting)" class="shadow-sm" data-hj-suppress>
               <b-card-body>
               <div class="meetingTitle">{{meeting.name}}</div>
               <span>{{ [ meeting.date] | moment("ddd DD MMM YYYY") }}</span> &nbsp; {{meeting.time}}
            </b-card-body>
             <b-list-group flush>
                 <b-list-group-item>
                   <div class="logHeader" v-if="meeting.agenda">Agenda</div>

                   <template v-if="meeting.agenda">
                     <div  v-for="item,idx in meeting.agenda.slice().sort((a,b) => {return a.position - b.position})">
                     <!-- <div  v-for="item, idx in meeting.agenda"> -->
                       <span class="aIndex" v-bind:class="'aIndex No' + item.position">{{idx + 1}}</span>&nbsp;
                       <span class="aItem">{{item.topic}} - {{item.duration}} min</span>
                    </div>
                  </template>
               </b-list-group-item>
            </b-list-group>
            </b-card>
          </b-col>
          </b-row>
        </b-container>
      </div>

      <!-- Past Meetings -->
      <div id="buttons" class="ml-5 mr-5">
        <!-- <h2 style="display:inline" v-if="pastMeetings && pastMeetings.length > 0">Past Meetings</h2> &nbsp;&nbsp;&nbsp; -->
        <span style="font-size: 1.4rem" class="sectionLabel">Past Meetings</span>&nbsp;&nbsp;&nbsp;
      </div>
      <div  class="ml-4 mr-4">
        <b-container fluid>
          <b-row>
            <b-col cols="4" v-for="(meeting, idx) in pastMeetings"  v-bind:key="idx">
            <b-card no-body @click="openMeeting(meeting)" class="shadow-sm" data-hj-suppress>
              <b-card-body>
                 <div class="meetingTitle">{{meeting.name}}</div>
                 <!-- <span>{{ [ meeting.date, 'YYYY/MM/DD'] | moment("ll") }}</span> -->
                 <span>{{ meeting.date | moment("ddd MMMM Do YYYY") }}</span>
                 &nbsp; {{meeting.time}}
              </b-card-body>
              <b-list-group flush>
                 <b-list-group-item>

                   <div v-if="meeting.log  && meeting.log.filter(x => x.logType==='decision').length > 0">
                     <div class="logHeader">What was agreed</div>
                       <div class="logItems">
                        <div class="log" v-for="decision in meeting.log.filter(x => x.logType==='decision')">
                          {{decision.text.substring(0.70)}}
                        </div>
                      </div>
                   </div>

                   <div v-if="meeting.log && meeting.log.filter(x => x.logType==='action').length > 0">
                      <div class="logHeader">Actions</div>
                      <div class="logItems">
                        <div class="log" v-for="action in meeting.log.filter(x => x.logType==='action')">
                           <font-awesome-icon v-if="action.actionStatus  && action.actionStatus == 'complete'" :icon="['far', 'check-square']" size="1x" style="Xfloat:right;color:green" v-b-tooltip.hover title="Mark Incomplete" @click.stop="toggleActionStatus(action,meeting)"/>
                          <font-awesome-icon v-else="action.actionStatus  && action.actionStatus == 'complete'" :icon="['far', 'square']" size="1x" style="Xfloat:right;color:red" v-b-tooltip.hover title="Mark Complete" @click.stop="toggleActionStatus(action,meeting)"/>
                          {{action.text.substring(0,70)}}
                        </div>
                    </div>
                   </div>

                    <div v-if="meeting.log  && meeting.log.filter(x => x.logType==='note').length > 0">
                     <div class="logHeader">Notes</div>
                       <div class="logItems">
                        <div class="log" v-for="decision in meeting.log.filter(x => x.logType==='note')">
                          {{decision.text.substring(0.70)}}
                        </div>
                      </div>
                      <!-- <div class="scrollFade">&nbsp;</div> -->
                   </div>

                 </b-list-group-item>
              </b-list-group>
            </b-card>

            </b-col>
          </b-row>
        </b-container>
      </div>
<!--      </template>-->
   <b-modal xhide-footer="true" ok-only centered size="lg" v-model="modalShowWelcomePersonal" title="Welcome to Moogenda Meetings">
     <layout flud>
       <b-row>
          <b-col sm="3"><img src="@/assets/WelcomeImageSide.png" style="Xheight:2.2rem"></b-col>
          <b-col sm='9'>
            <div id="welcomeText">
             <p>
               Hi {{user.displayName.split(' ')[0]}}, thank you for signing up to Moogenda!
             </p>
             <p>
               Click
               <!-- <img src="@/assets/NewMeetingButtonImage.png" style="height:2.2rem"> -->
               <img src="@/assets/MeetNowButtonImage.png" style="height:2.2rem"> or
               <img src="@/assets/ScheduleMeetingButtonImage.png" style="height:2.2rem">
                to create your first meeting.  You can then create an agenda and add your attendees.
             </p>
             <p>
               We hope your meetings are more effective and more fun from now on!
             </p>
             <p>
               If you have any questions or problems then just use the chat window <img src="@/assets/LiveChatIcon.png" style="height:1.9rem"> at the bottom of the screen and we'll sort it out!
             </p>
           </div>
          </b-col>
       </b-row>
     </layout>
    <div slot="modal-footer">
      <b-button size="sm" variant="primary" @click="modalShowWelcomePersonal=false">Get Started</b-button>
    </div>
  </b-modal>

    </div>
</template>

<script>
import { firebase, db, router } from '../main'
const axios = require('axios')
export default {
  name: 'MyMeetings',
  props: ['user'],
  data () {
    return {
      meetings: [],
      removeMeeting: {},
      filterDate: 'Future',
      logCollection: [],
      meetingSearchTerm: '',
      modalShowWelcomePersonal: false
    }
  },
  computed: {
    upcomingMeetings () {
      var filterDate = this.$moment().subtract(1,'day').format('YYYY-MM-DD')
      return this.meetings.filter(x => this.$moment(x.date + ' ' + x.time).add(x.duration, 'minutes').isAfter() && x.name.toLowerCase().includes(this.meetingSearchTerm.toLowerCase())).sort((a, b) => {
        // return this.$moment(a.date) - this.$moment(b.date)
      return this.$moment(a.date + ' ' + a.time, 'YYYY/MM/DD hh:mm') - this.$moment(b.date + ' ' + b.time, 'YYYY/MM/DD hh:mm')
      })
    },
    pastMeetings () {
      return this.meetings.filter(x => this.$moment(x.date + ' ' + x.time).add(x.duration, 'minutes').isBefore() && x.name.toLowerCase().includes(this.meetingSearchTerm.toLowerCase())).sort((a, b) => {
        // return this.$moment(b.date + ' ' + b.time, 'YYYY/MM/DD hh:mm') - this.$moment(a.date + ' ' + a.time, 'YYYY/MM/DD hh:mm')
        return this.$moment(b.date) - this.$moment(a.date)
      })
    },
    dateTime (){
      return this.$moment('2019-09-28' + ' ' + '12:50').add(30,'minutes')
    }
  },
  methods: {
    meetNow () {
      // Create a meeting Entry & attendees
      var meetingDate = this.$moment().format('YYYY-MM-DD')
      var meetingTime = this.$moment().format('HH:mm')
      db.collection('Meetings').add({name:'My Meeting', date:meetingDate, time: meetingTime, owner: this.user.uid, duration: 30}).then((docRef) => {
        db.collection('Meetings').doc(docRef.id).collection('attendees').add({email:this.user.email, name: this.user.displayName, status: "Not here yet"})
        router.push({name: 'ViewMeeting', query: {id: docRef.id}})
      })

      // Redirect to view Meeting
    },
    // test2 () {
    //   var vm = this
    //   var accountDocRef = db.collection('Accounts').doc(this.user.email)
    //   accountDocRef.get().then( (doc) =>  {
    //     debugger
    //     alert(vm)
    //     console.log('here')
    //   })
    // },
    test () {
      const logRef = db.collection('Meetings').doc('XncRNPLa1OEvavpxfB8k').collection('log')
      const agendaRef = db.collection('Meetings').doc('XncRNPLa1OEvavpxfB8k').collection('agenda')
      var promises = []
      promises.push(logRef.get())
      promises.push(agendaRef.get())
      Promise.all(promises).then(values => {
        console.log(values[0].docs.map(x => x.data()))
        console.log(values[1].docs.map(x => x.data()))
      })
    },
    openMeeting (meeting) {
      // router.push({name: 'ViewMeeting', params: {id: meeting.id}})
      router.push({name: 'ViewMeeting', query: {id: meeting.id}})

      // router.push({ path: 'register', query: { plan: 'private' }})
    },
    toggleActionStatus (action,meeting) {
      // alert('Update meeting:' + meeting.id + '\n' + 'action:' + action.id)
      if (action.actionStatus && action.actionStatus == 'complete') {
        console.log('mark complete')
        db.collection('Meetings').doc(meeting.id).collection('log').doc(action.id).update({actionStatus:  firebase.firestore.FieldValue.delete()})

      } else {
        console.log('mark incomplete')
        db.collection('Meetings').doc(meeting.id).collection('log').doc(action.id).update({actionStatus: 'complete'})
      }

    }
  },
  mounted: function () {
    mixpanel.track('View My Meetings')
    if (this.$route.query.WelcomePersonal == 'y') {
      this.modalShowWelcomePersonal=true
      // Update the plan in the database
      db.collection('Accounts').doc(this.user.email).update({plan:'Personal'})
      // Update the plan displayed in App.vue
      this.$emit('planChanged', 'Personal');
    } else if (this.$route.query.WelcomeFree == 'y') {
        this.modalShowWelcomePersonal=true
    }
  },
  firestore () {
    return {
      meetings: db.collection('Meetings').where('owner', '==', this.user.uid)
    }
  }
}
</script>

<style scoped>
  #buttons{margin-top: 20px; margin-bottom:20px}
   .card.itemCutOut {margin-top:1.4rem;border: dashed 1px rgba(0, 0, 0, 0.25); height:5rem;justify-content:center;align-items:center;font-weight:400;color:gray;font-weight: 500; Xmax-width: 20rem; xmargin-left: 3rem}
  .card{margin-bottom: 1rem;; min-height: 8rem; max-width: 95rem; Xpadding:0.5rem}
  .card-body{padding:.8rem; Xbackground-color: aquamarine}
  .list-group-item {padding: 0.4rem 0.8rem; min-height: 4rem}
  .meetingTitle {font-size:1.2rem; font-weight:bold}
  .decisionsHeader {font-size: 0.8rem;margin-top:0.2rem}
  .logHeader {font-size: 0.8rem; font-weight: bold}
  .log{background-color: var(--lightGray);font-size: 0.8rem;padding:0.2rem;margin-bottom:0.2rem; border-radius:0.3rem}
  .logItems{max-height:6.2rem; overflow: scroll}
  .scrollFade{
    min-height:3rem;
    position:relative; top:-3rem;
    background: linear-gradient(rgba(247,247,246,0),rgba(247,247,246,1));
    Xbackground-color: pink}
  .actionDone{color:yellow}
  .aIndex{font-size:0.7rem;color:white; xborder:grey solid 1px; border-radius:50%; font-weight:bold; width:1.1rem; height:1.1rem; line-height:1.1rem;display: inline-block; text-align:center; padding:0;margin: 0}
  .aItem{font-size:0.8rem;margin:.5rem 0rem}
  #welcomeText {height:50vh; font-size:1.2rem; margin:1.5rem 0}
  #welcomeText p {margin: 1.5rem 0}
</style>
